import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const authToken = localStorage.getItem('adminAuthToken');
    const authExpiry = localStorage.getItem('adminAuthExpiry');
    
    if (authToken && authExpiry) {
      const expiryTime = parseInt(authExpiry);
      if (Date.now() < expiryTime) {
        setIsAuthenticated(true);
      } else {
        // Token expired, clear it
        localStorage.removeItem('adminAuthToken');
        localStorage.removeItem('adminAuthExpiry');
      }
    }
    setIsLoading(false);
  }, []);

  const login = async (username, password) => {
    // Hardcoded authentication (sementara tanpa backend)
    // GANTI username dan password di bawah ini untuk keamanan:
    const ADMIN_USERNAME = 'admin';
    const ADMIN_PASSWORD = '26merdekakuid';
    
    // Simple validation
    if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
      const token = btoa(`${username}:${Date.now()}`);
      const expiry = Date.now() + (24 * 60 * 60 * 1000); // 24 hours
      
      localStorage.setItem('adminAuthToken', token);
      localStorage.setItem('adminAuthExpiry', expiry.toString());
      setIsAuthenticated(true);
      return { success: true };
    }
    
    return { success: false, message: 'Username atau password salah' };
  };

  const logout = () => {
    localStorage.removeItem('adminAuthToken');
    localStorage.removeItem('adminAuthExpiry');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
